import { render, staticRenderFns } from "./versionChecker.vue?vue&type=template&id=409084a6&scoped=true"
import script from "./versionChecker.vue?vue&type=script&lang=js"
export * from "./versionChecker.vue?vue&type=script&lang=js"
import style0 from "./versionChecker.vue?vue&type=style&index=0&id=409084a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409084a6",
  null
  
)

export default component.exports